const React = require('react'),
    {PropTypes} = require('react'),
    {t} = require('services/i18nextWrapper'),
    SessionStore = require('stores/SessionStore'),
    TextField = require('components/Commons/TextField/TextField'),
    getBoundingClientRect = require('bounding-client-rect'),
    DashboardServiceCache = require('services/DashboardServiceCache'),
    _ = require('lodash'),
    DashboardModalTaskCollapsibleContent = require('./DashboardModalTaskCollapsibleContent'),
    {
        TASK_NON_VISIBLE,
        TYPE_TASK_FERMENTER
    } = require('constants/AppConstants'),
    ComponentUtils = require('utils/ComponentUtils'),
    ContentUtils = require('utils/ContentUtils'),
    DropDown = require('components/Commons/DropDown/DropDown'),
    PositionUtils = require('utils/PositionUtils');


const iconsProvider = {
    // notice in the following declaration we are passing the context,
    // because inside of method we need to be the DSC context.
    ['FERMENTER_TASK']: DashboardServiceCache.getFermenterIcons.bind(DashboardServiceCache),
    ['FV']: DashboardServiceCache.getFermenterIcons.bind(DashboardServiceCache),
    ['PACKAGING_TASK']: DashboardServiceCache.getPackagingIcons.bind(DashboardServiceCache),
    ['BT']: DashboardServiceCache.getPackagingIcons.bind(DashboardServiceCache),
    ['BREWHOUSE_TASK']: DashboardServiceCache.getBrewhouseIcons.bind(DashboardServiceCache),
    ['BH']: DashboardServiceCache.getBrewhouseIcons.bind(DashboardServiceCache)
};

const DashboardModalTaskCollapsible = React.createClass({displayName: "DashboardModalTaskCollapsible",

    propTypes: {
        date: PropTypes.string,
        order: PropTypes.object,
        uniqueId: PropTypes.string,
        existingTask: PropTypes.object,
        existingProcess: PropTypes.object,
        indexDay: PropTypes.number,
        name: PropTypes.string,
        orderProcess: PropTypes.array,
        onChangeTaskType: PropTypes.func,
        onBlurLabel: PropTypes.func,
        onBlurDescription: PropTypes.func,
        onToggleExpand: PropTypes.func,
        onChangeProcess: PropTypes.func,
        onChangeProducts: PropTypes.func,
        onChangeAmountInLocation: PropTypes.func,
        onChangeAmountItem: PropTypes.func,
        onChangeVolumeItem: PropTypes.func,
        isEditMode: PropTypes.bool,
        onDeleteTask: PropTypes.func,
        typeTask: PropTypes.string,
        typeTaskClassName: PropTypes.string,
        tasks: PropTypes.array,
        onConfirmProduct: PropTypes.func.isRequired
    },

    onToggleExpand() {
        this.setState(prevState => {
            return {
                isCollapsed: !prevState.isCollapsed
            };
        }, () => {
                if (this.props.onToggleExpand) {
                    this.props.onToggleExpand();
                }
            }
        );
    },

    getInitialState() {
        return {
            isCollapsed: true
        };
    },

    componentDidMount() {
        // Force focus to proper task clicked
        _.delay(() => {
            this._focusElement();
        }, 500); // set time out in order to fix issue about non focus setting
    },

    _focusElement(){
        const dropdownSelected = document.querySelector('.is-focused input');

        if (dropdownSelected && this.isMounted()) {
            const dropdownSelectedEl = ContentUtils.getComponentByClassName(dropdownSelected, 'modal-order-task-list-item');
            const indexDay = +dropdownSelectedEl.getAttribute('data-index-day');
            const parentScrollEl = PositionUtils.getParentScroll(dropdownSelected);
            const heightDayRow = getBoundingClientRect(dropdownSelectedEl).height;
            const modalHalfHeight = getBoundingClientRect(parentScrollEl).height / 2;
            let positionHeight = indexDay * heightDayRow;

            if (positionHeight < modalHalfHeight) {
                // enter here means that we are clicked on days before the middle of height of dashboard
                positionHeight = 0;
            } else {
                //
                positionHeight = positionHeight - modalHalfHeight;
            }

            parentScrollEl.scrollTop = positionHeight;
            dropdownSelected.focus();
        }
    },

    render() {
        const {
            onDeleteTask,
            onBlurDescription,
            onChangeTaskType,
            tasks,
            onBlurLabel,
            date,
            indexDay,
            existingTask,
            typeTask,
            typeTaskClassName,
            name,
            orderProcess,
            existingProcess,
            uniqueId,
            onChangeProcess,
            onChangeProducts,
            onChangeAmountItem,
            onChangeVolumeItem,
            isEditMode,
            onChangeAmountInLocation,
            onConfirmProduct,
            order,
            shouldBeDisabled
        } = this.props;

        const taskLabelClassName = 'modal-order-task-list-item-label col-xs-2 ' + typeTaskClassName;
        let notesEl;
        let classNameDescription;
        const payloadNonIcon = _.findIndex(tasks, task => task.name === TASK_NON_VISIBLE) + 1;

        if (name) {
            notesEl = (
                React.createElement("span", {className: "modal-order-task-list-item-date col-xs-2"}, 
                    name
                )
            );
            classNameDescription = 'modal-order-task-list-item-description col-xs-2';
        } else {
            notesEl = null;
            classNameDescription = 'modal-order-task-list-item-description col-xs-4';
        }

        const classNameIconPlus = !this.state.isCollapsed ? 'material-icons toggle-icon modal-order-task-list-item__receipe is-expanded' : 'material-icons toggle-icon modal-order-task-list-item__receipe';
        const someProductConfirmed = _.some(_.get(existingTask, 'products'), product => _.get(product, 'isConfirmed'));
        const taskMenus = iconsProvider[typeTask]();
        const isDisabled = someProductConfirmed || (SessionStore.isAdminUser() ? false : shouldBeDisabled);

        return (
            React.createElement("li", {"data-section-type": typeTask, "data-index-day": indexDay + 1, key: uniqueId, className: "modal-order-task-list-item row"}, 
                React.createElement("span", {className: "modal-order-task-list-item-date col-xs-2"
                }, date), 
                React.createElement("span", null, notesEl), 
                React.createElement("span", {className: "modal-order-task-list-item-typetask col-xs-3"}, 
                    React.createElement(DropDown, {
                        floatingLabelText: t('icon'), 
                        name: t('dashboard_modal_task_icon'), 
                        key: 'typeTask-' + indexDay+ _.get(existingTask, 'id') + this.props.uniqueId, 
                        selectedIndex: !existingTask || existingTask.payload === 0 ? payloadNonIcon : existingTask.payload, 
                        readerAttribute: "displayName", 
                        autoWidth: false, 
                        onChange: onChangeTaskType.bind(existingTask), 
                        items: taskMenus, 
                        menuItems: ComponentUtils.toMenuItems(tasks, 'displayName', 'icon', `modal-order-type-task-${typeTask === TYPE_TASK_FERMENTER ? 'fv' : 'bt'}-locator-`), 
                        disabled: isDisabled, 
                        style: {width: '102%'}}
                    )
                ), 
                React.createElement("span", {className: taskLabelClassName}, 
                    React.createElement(TextField, {
                        floatingLabelText: t('label'), 
                        errorStyle: {color: 'orange'}, 
                        value: _.get(existingTask, 'label'), 
                        disabled: isDisabled, 
                        key: 'taskLabel-' + indexDay+ _.get(existingTask, 'id'), 
                        onBlur: onBlurLabel
                    }
                    )
                 ), 
                React.createElement("span", {className: classNameDescription}, 
                    React.createElement(TextField, {
                        floatingLabelText: t('note'), 
                        value: _.get(existingTask, 'description'), 
                        key: 'taskDescription-' + indexDay+ _.get(existingTask, 'id'), 
                        onBlur: onBlurDescription, 
                        disabled: isDisabled
                    }
                    )
                ), 
                React.createElement("span", {className: "modal-order-task-list-item-delete col-xs-1"}, 
                    React.createElement("i", {title: t('dashboard_modal_task_delete_task'), 
                       style: {display: 'none'}, /* display: showDeleteIcon ? 'inline' : 'none' Temporary hidden  */
                       className: "material-icons md-16", 
                       onClick: onDeleteTask}, "delete")
                ), 
                React.createElement("span", {className: classNameIconPlus}, 
                    
                        this.state.isCollapsed ? (
                            React.createElement("i", {title: t('dashboard_modal_task_add_recipe'), 
                               "data-test-id": "expand-task", 
                               className: "material-icons md-16", 
                               onClick: this.onToggleExpand}, "add_circle_outline")
                        ) : (
                            React.createElement("i", {title: t('dashboard_modal_task_add_recipe'), 
                               "data-test-id": "expand-task", 
                               className: "material-icons md-16", 
                               onClick: this.onToggleExpand}, "remove_circle_outline")
                        )
                    
                ), 
                React.createElement(DashboardModalTaskCollapsibleContent, {
                    key: 'collapsible-content-' + indexDay + _.get(existingTask, 'id'), 
                    existingTask: existingTask, 
                    existingProcess: existingProcess, 
                    orderProcess: orderProcess, 
                    shouldBeDisabled: shouldBeDisabled, 
                    order: order, 
                    onChangeProcess: onChangeProcess, 
                    onChangeProducts: onChangeProducts, 
                    onConfirmProduct: onConfirmProduct, 
                    onChangeAmountItem: onChangeAmountItem, 
                    onChangeVolumeItem: onChangeVolumeItem, 
                    onChangeAmountInLocation: onChangeAmountInLocation, 
                    isCollapsed: this.state.isCollapsed, 
                    isEditMode: isEditMode}
                )
            )
        );
    }
});

module.exports = DashboardModalTaskCollapsible;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardModal/DashboardModalTask/DashboardModalTaskCollapsible.jsx
 **/